import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { TOTP } from "totp-generator";
import { Card, CardBody } from "reactstrap";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useGetOtpKeyQuery } from "../../../redux/services/cartSearchService";

interface OTPData {
  otp: any;
  expires: number;
}

const Configuration: React.FC = () => {
  const OTP_DURATION = 30;

  const [otpData, setOtpData] = useState<OTPData>({ otp: "", expires: 0 });
  const [countdown, setCountdown] = useState<number>(OTP_DURATION);
  const [timerKey, setTimerKey] = useState<number>(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showGenerateButton, setShowGenerateButton] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showRegenerateButton, setShowRegenerateButton] = useState(false);

  const { data, isLoading } = useGetOtpKeyQuery("");

  const saveToLocalStorage = (otp: any, expires: number) => {
    localStorage.setItem(
      "otpData",
      JSON.stringify({ otp: otp, expires: expires })
    );
  };

  const loadFromLocalStorage = (): OTPData | null => {
    const storedOtpData = localStorage.getItem("otpData");
    if (storedOtpData) {
      return JSON.parse(storedOtpData);
    }
    return null;
  };

  const generateOTP = (otpKey: string) => {
    setShowGenerateButton(false);
    const timestamp = Date.now();

    if (otpKey) {
      const generatedOtp = TOTP.generate(otpKey, {
        digits: 6,
        algorithm: "SHA-1",
        period: OTP_DURATION,
        timestamp: timestamp,
      });

      const currentTimestamp = Math.floor(Date.now() / 1000);

      const timeElapsedInInterval = currentTimestamp % OTP_DURATION;

      const RemainingTime = OTP_DURATION - timeElapsedInInterval;
      setOtpData({
        otp: generatedOtp,
        expires: RemainingTime,
      });

      saveToLocalStorage(generatedOtp, RemainingTime);
      setCountdown(RemainingTime);
      setTimerKey((prevKey) => prevKey + 1);
    }

  };

  // const regenerateOTP = () => {

  //   const newOtp = TOTP.generate(data?.otpKey, {
  //     digits: 6,
  //     algorithm: "SHA-1",
  //     period: OTP_DURATION,
  //     timestamp: Date.now(),
  //   });
  //   const storedOtpData = loadFromLocalStorage();

  //   if (storedOtpData?.otp.otp !== newOtp.otp) {
  //     generateOTP(data?.otpKey);
  //     setDisableRegenerateButton(false);
  //   } else {
  //     if (countdown == 0) {
  //       setDisableRegenerateButton(false);
  //       generateOTP(data?.otpKey);
  //     }
  //     setDisableRegenerateButton(true);
  //   }
  // };

  useEffect(() => {
    const storedOtpData = loadFromLocalStorage();

    if (storedOtpData && storedOtpData.expires > Date.now()) {
      setOtpData(storedOtpData);
      const remainingTime = Math.max(
        0,
        Math.floor((storedOtpData.expires - Date.now()) / 1000)
      );
      setCountdown(remainingTime);
      setTimerKey((prevKey) => prevKey + 1);
    } else if (data && !isLoading) {
      generateOTP(data?.otpKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (otpData.expires > Date.now()) {
        const remainingTime = Math.max(
          0,
          Math.floor((otpData.expires - Date.now()) / 1000)
        );
        setCountdown(remainingTime);
      } else {
        setCountdown(0);
        localStorage.removeItem("otpData");
        generateOTP(data?.otpKey);
      }
    }, 1000);

    return () => clearInterval(countdownInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpData.expires, data]);

  //Comment Added

  return (
    <div>
      <BreadCrumbs hasSubMenus={false} />
      <Card>
        <CardBody>
          <h6 className="d-flex justify-content-start">
            ▪️ Use this OTP to Configure Cart Device
          </h6>
          <>
            <h1 className="d-flex justify-content-center">{otpData.otp.otp}</h1>

            <div className="d-flex justify-content-center">
              <CountdownCircleTimer
                key={timerKey}
                isPlaying={countdown > 0}
                duration={OTP_DURATION}
                initialRemainingTime={countdown}
                colors="#A30000"
                onComplete={() => {
                  setShowGenerateButton(true);
                  setShowRegenerateButton(true);
                  return { shouldRepeat: false };
                }}
              >
                {() => (
                  <div style={{ fontSize: "24px", fontWeight: "bold" }}>
                    {countdown > 0 ? `${countdown} s` : "Expired"}
                  </div>
                )}
              </CountdownCircleTimer>
            </div>
          </>
        </CardBody>
      </Card>
    </div>
  );
};

export default Configuration;
